import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import {
  Button,
  TextField,
  MuiThemeProvider,
  createMuiTheme,
  FormControlLabel,
  Checkbox
} from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { deleteUser, getUserById, postUser, updateUser } from '../../../../api/user'
import { useSkeleton } from '../../../hooks/useSkeleton'
import { alertError, alertSuccess } from '../../../../utils/logger'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: '#F64E60'
    }
  }
})

function getEmptyAdmin() {
  return {
    fullName: '',
    email: '',
    role: 'admin',
    password: '',
    repeatPassword: '',
    active: true
  }
}

export default function EditAdminsPage() {
  const [admin, setAdmin] = useState(getEmptyAdmin())
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [newPassword, setNewPassword] = useState({ password: null, repeatPassword: null })
  const [changePassword, setChangePassword] = useState(false)
  const adminId = useParams().id;
  const history = useHistory();

  const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton();

  useEffect(() => {
    if (!adminId) {
      disableLoadingData();
      return
    }

    getUserById(adminId).then(res => {
      const user = res.data
      delete user.password
      setAdmin(user)
      disableLoadingData();
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get admin.' })
      history.push('/admins')
    })
  }, [adminId, disableLoadingData, history])

  function saveAdmin() {
    let saveAdmin = admin
    if (saveAdmin.fullName === '') {
      alertError({ error: null, customMessage: 'Name is required.' });
      return;
    }
    if (saveAdmin.email === '') {
      alertError({ error: null, customMessage: 'Email is required.' });
      return;
    }


    if (!adminId || changePassword) {
      if (!newPassword.password || !newPassword.repeatPassword) {
        alertError({ error: null, customMessage: 'Please enter the password.' });
        return;
      }
      if (newPassword.password !== newPassword.repeatPassword) {
        alertError({ error: null, customMessage: 'Passwords do not match.' });
        return;
      }
      saveAdmin = { ...saveAdmin, password: newPassword.password };
    }


    if (!adminId) {
      postUser(saveAdmin).then(res => {
        alertSuccess({ title: 'Saved!', customMessage: 'Admin successfully created.' })
        history.push('/admins')
      }).catch(error => {
        alertError({ error: error, customMessage: 'Could not save admin.' })
      })
    } else {
      updateUser(adminId, saveAdmin).then(res => {
        alertSuccess({ title: 'Saved!', customMessage: 'Changes successfully saved.' })
        history.push('/admins')
      }).catch(error => {
        alertError({ error: error, customMessage: 'Could not save changes.' })
      })
    }
  }

  const handleChange = (element) => (event) => {
    setAdmin({ ...admin, [element]: event.target.value })
  }

  if (isLoadingData)
    return <ContentSkeleton />

  return (
    <>
      <Card>
        <CardHeader title='Edit admin'>
        </CardHeader>
        <CardBody>
          <div className="d-flex align-item-center">
            <div className="col-5">
              <TextField
                label="Full name"
                value={admin.fullName}
                onChange={handleChange('fullName')}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
            <div className="col-5">
              <TextField
                label="Email"
                value={admin.email}
                onChange={handleChange('email')}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
          </div>
          <div className="d-flex flex-wrap align-item-center">
            {!adminId || changePassword ? (
              <>
                <div className="col-4">
                  <TextField
                    label="Password"
                    type="password"
                    value={newPassword.password}
                    onChange={(e) =>
                      setNewPassword({
                        ...newPassword,
                        password: e.target.value,
                      })
                    }
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    required
                  />
                </div>
                <div className="col-4">
                  <TextField
                    label="Repeat Password"
                    type="password"
                    value={newPassword.repeatPassword}
                    onChange={(e) =>
                      // if (event.target.value !== ' ')
                      setNewPassword({
                        ...newPassword,
                        repeatPassword: e.target.value,
                      })
                    }
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    required
                  />
                </div>
                <div className="col-2" />

                {/* TODO REVISAR*/}
                {adminId && (
                  <>
                    <div className="col-5" />
                    <div className="d-flex align-item-center mt-2">
                      <Button
                        onClick={() => {
                          setChangePassword(false);
                          setNewPassword({ password: null, repeatPassword: null });
                        }}
                        variant="outlined"
                      >
                        Cancel change password
                      </Button>
                    </div>
                  </>
                )}
              </>
            ) : (
              <Button
                onClick={() => setChangePassword(true)}
                variant="outlined"
                color="primary"
                style={{ marginTop: 10 }}
              >
                Change password
              </Button>
            )}
          </div>

          <br />
          <FormControlLabel
            control={<Checkbox checked={admin.active} onChange={() => setAdmin({ ...admin, active: !admin.active })} name="checkActive" />}
            label="Active"
          />
        </CardBody>
      </Card>

      <Button
        onClick={() => history.push('/admins')}
        variant="outlined"
        style={{ marginRight: '20px' }}>
        Back
      </Button>

      <Button
        onClick={() => saveAdmin()}
        variant="outlined"
        color="primary"
        style={{ marginRight: '20px' }}>
        Save admin
      </Button>

      {adminId && <>
        <MuiThemeProvider theme={theme}>
          <Button
            onClick={() => setOpenConfirmDialog(true)}
            variant="outlined"
            color="secondary">
            Delete admin
          </Button>
        </MuiThemeProvider>

        <ConfirmDialog
          title={'Are you sure you want to delete this admin?'}
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deleteUser(adminId).then(res => {
              alertSuccess({ title: 'Deleted!', customMessage: 'Admin deleted successfully' })
              history.push('/admins')
            }).catch(error => {
              alertError({ error: error, customMessage: 'Could not delete admin.' })
            })
          }}
        />
      </>}
    </>
  );
}
